import { Dispatch, SetStateAction } from 'react';
import { UseQueryResult, useQuery, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { getRockerboxApplicantsRoute, getRockerboxDocumentsRoute } from '../api/constant';
import { rockerboxDocumentsKey } from '../constants';

type useGetRockerboxDocumentssProps = {
    searchValue?: string;
    statusValue?: string;
    companyId: number;
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetRockerboxDocuments = ({
    companyId,
    searchValue,
    statusValue,
    setErrorText = () => { },
}: useGetRockerboxDocumentssProps) => {
    const queryString = `?company_id=${companyId}&query=${searchValue}`;
    const { data: documentsList, isFetching: isLoadingDocumentsList }: UseQueryResult<any, any> = useQuery({
        queryKey: [rockerboxDocumentsKey, companyId, statusValue, searchValue],
        queryFn: () =>

            axiosInstance
                .get(getRockerboxDocumentsRoute + queryString)
                .then((res) => res.data),
        // enabled: !!companyId,
        onSuccess: (data) => {
            setErrorText('');
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchOnWindowFocus: false,
    });

    return {
        documentsList,
        isLoadingDocumentsList,
    };
};
